import http from "./../../services/api";
import queryString from "query-string";
import store from "../index";
import * as types from "./../types/enderecos";
import axios from 'axios';

export const loadEnderecos = filtro => {
  return dispatch => {
    dispatch({ type: types.LOADING_ENDERECOS, payload: true });
    http.get(`/api/v1/enderecos/list`).then(
      response => {
        const data = response.data
        dispatch([
          { type: types.SET_ENDERECOS, payload: data},
          { type: types.LOADING_ENDERECOS, payload: false }
        ]);
      },
      error => {
        console.log(error);
        dispatch({ type: types.LOADING_ENDERECOS, payload: false });
      }
    );
  };
};



export function inserirEnderecos(enderecos ) {

  return new Promise((resolve, reject) => {
    store.dispatch({ type: types.LOADING_ENDERECOS, payload: true });
    http.post(`/api/v1/enderecos/insert`, enderecos)
      .then(
        ({ data }) => {          
          store.dispatch({ type: types.LOADING_ENDERECOS, payload: false });
          resolve();
        },
        (e) => {
          store.dispatch({ type: types.LOADING_ENDERECOS, payload: false });
          reject();
        }
      );
  });
}

export function editarEnderecos(enderecos, id ) {

  return new Promise((resolve, reject) => {
    store.dispatch({ type: types.LOADING_ENDERECOS, payload: true });
    http.post(`/api/v1/enderecos/edit/${id}`, enderecos)
      .then(
        ({ data }) => {
          
          store.dispatch({ type: types.LOADING_ENDERECOS, payload: false });
          resolve();
        },
        (e) => {
          store.dispatch({ type: types.LOADING_ENDERECOS, payload: false });
          reject();
        }
      );
  });
}

export function disabledFuncionario(id ) {

  return new Promise((resolve, reject) => {
    store.dispatch({ type: types.LOADING_ENDERECOS, payload: true });
    http.put(`/api/v1/funcionarios/disable/${id}`,)
      .then(
        ({ data }) => {
          
          store.dispatch({ type: types.LOADING_ENDERECOS, payload: false });
          resolve();
        },
        (e) => {
          store.dispatch({ type: types.LOADING_ENDERECOS, payload: false });
          reject();
        }
      );
  });
}
